import moment from 'moment';
let startDt = moment().startOf('month').format('YYYYMMDD');
let endDt = moment().endOf('month').format('YYYYMMDD');

export default {
	lugyCdList: [], //긴급도 selectBox
	pgsStPcCdList: [], //진행상태 selectBox
	pgsStLpCdList: [], //진행상태 selectBox
	pgsStKdCdList: [], //진행상태(KD) selectBox
	badTypeLgrpCdList: [], //유형 selectBox
	occuPlCdList: [], //발생장소 selectBox
	rptpPrcsCdList: [], //고품처리 selectBox
	mdvRplCdList: [], //대책회신 selectBox
	partGCdList: [], //소싱구분 selectBox
	sndStCdList: [], //메일발송상태 selectBox

	clmPgsStCdList: [], //클래임 진행상태
	clmRsltCdList: [], //판정결과
	judgedStateList: [], //판정진행상태
	tpWayCdList: [], //운송수단
	clmTypeGlsCdList: [], //클래임유형.
	clmOccuPlCdList: [], //발생장소(glims)

	useYnList: [],
	resultList: [],
	partCkuScrId: '', // 부품검사 화면 ID(품명 클릭시 부품검사 화면으로 이동하기 위해 필요함)
	searchParams: SEARCH_PARAMS(),
	searchPopupParams: SEARCH_POPUP_PARAMS(),
	pagingInfo: PAGING_INFO(),
	detailForm: DETAIL_FORM(),
	badTypeLv1List: [],
	badTypeLv2List: [],
	badTypeLv3List: [],
	rcptInfo: new Map(), //수신자 메일정보
	rfpInfo: new Map(), //참조자 메일정보
	partMstInfo: PART_MST_INFO(),
	glimsFileList: [], // Glims fileList
	pprHistoryList: [], //개선이력 목록,
	historyPagingInfo: HISTORY_PAGING_INFO(),
	pprNoPopupSearch: PPR_NO_POPUP_SEARCH(),
	pprNoPagingInfo: PPR_NO_PAGING_INFO(), //pprNo팝업 페이징
	pprNoPopupList: [], //pprNo팝업 목록

	feTarget: '', //fe 주소
	ubiTarget: '' //ubi report 주소
};

function SEARCH_PARAMS() {
	return {
		pprNo: '',
		partNo: '',
		partNm: '',
		pgsStCd: '',
		ckuNo: '',
		cofCd: '',
		cofNm: '',
		strDt: startDt,
		endDt: endDt,
		partGCd: ''
	};
}

function SEARCH_POPUP_PARAMS() {
	return {
		pprNo: '',
		partNo: ''
	};
}

function PPR_NO_POPUP_SEARCH() {
	return {
		pprNo: '',
		partNo: '',
		partNm: '',
		cofCd: '',
		cofNm: ''
	};
}

function PPR_NO_PAGING_INFO() {
	return {
		currentPage: 1,
		endPage: 1,
		pageUnit: 30,
		startPage: 1,
		totalSize: 0
	};
}

function PAGING_INFO() {
	return {
		currentPage: 1,
		endPage: 1,
		pageUnit: 30,
		startPage: 1,
		totalSize: 0
	};
}

function PART_MST_INFO() {
	return {
		partNo: '',
		koPartNm: '',
		enPartNm: '',
		chPartNm: '',
		partGCd: '',
		partTypeCd: '',
		bascUtm: '',
		useYn: '',
		ckuTm: '',
		ckuScnCd: ''
	};
}

// Form영역 데이터
function DETAIL_FORM() {
	return {
		pprNo: '', //불량번호
		partNo: '', //부품번호
		lotFromNo: '', //LOT 시작번호
		lotToNo: '', //LOT 종료번호
		partGCd: '', //부품그룹코드(소싱)
		cofCd: '', //협력업체코드
		cofNm: '', //협력업체명
		ckuNo: '', //검사번호
		overSrgNo: '', //OS&D번호
		occuPlCd: '', //발생장소코드
		occuPlNm: '', //발생장소명
		lugyCd: '', //긴급도코드
		badQty: '', //불량수량
		sprtQty: '', //격리수량
		ckuQty: '', //검사수량
		occuDd: '', //발생일
		pprsDd: '', //제기일
		rplRqDd: '', //회신요청일
		clmNo: '', //클레임번호
		clmTypeCd: '', //클레임유형코드
		clmTypeNm: '', //클레임유형명
		lotQty: '', //LOT수량
		tpWayCd: '', //운송방법코드
		tpWayNm: '', //운송방법명
		clmPgsStCd: '', //클레임진행상태코드
		clmPgsStNm: '', //클레임진행상태명
		clmRsltCd: '', //클레임결과코드
		clmRsltNm: '', //클레임결과명
		badTypeLgrpCd: '', //불량유형대분류코드
		badTypeLgrpNm: '', //불량유형대분류명
		badTypeMgrpCd: '', //불량유형중분류코드
		badTypeMgrpNm: '', //불량유형중분류명
		badTypeSgrpCd: '', //불량유형소분류코드
		badTypeSgrpNm: '', //불량유형소분류명
		mdvRplCd: '', //대책회신코드
		rplSbc: '', //회신내용
		lnStpTm: '', //라인정지시간
		badTitlSbc: '', //불량제목내용
		badSbc: '', //불량내용
		badFileId: '', //불량파일ID
		badFile: [], //불량파일 목록
		normImgFileId: '', //정상이미지파일ID
		normImgFile: {}, //정상이미지파일
		badImgFileId: '', //불량이미지2파일ID
		badImgFile: {}, //불량이미지2파일
		badCausSbc: '', //변경원인내용
		badCausFileId: '', //불량원인파일ID
		badCausFile: [], //불량원인파일
		bttmMdvSbc: '', //개선대책내용
		bttmLotNo: '', //개선LOT번호
		mdvDd: '', //대책일
		rptpPrcsCd: '', //고품처리코드
		mdvPprrId: '', //대책작성자ID
		mdvPprrNm: '', //대책작성자명
		pgsStCd: '', //진행상태코드
		affrPrcsId: '', //업무처리ID
		emlSndNo: '', //메일발송번호
		rgnId: '', //등록자

		/**db에서 받는 파일 정보 */
		badFileDb: [],
		badCausFileDb: [],
		normImgFileDb: {},
		badImgFileDb: {},

		/* 이메일 관련 정보 */
		affrScnCd: '', //업무구분코드
		sndStCd: 'NSND', //발송상태코드
		sndDd: '', //발송일시
		dsprId: '', //발신자ID
		dsprNm: '', //발신자명
		rcptNm: '', //수신자명(조치처)
		rfpNm: '', //참조자명
		dsprAdr: '', //발신자주소
		rcptAdr: '', //수신자주소(조치처)
		rfpAdr: '', //참조자주소
		emlTitl: '', //메일제목
		emlSbc: '', //메일내용
		mesEqipNo: '', //측정기관리번호
		etMsg: '', //전송메시지
		rmk: '',

		/* 결재 관련 정보 */
		affrDspoId1: '',
		affrDspoNm1: '',
		affrPrcsDt1: '',
		affrDspoId2: '',
		affrDspoNm2: '',
		affrPrcsDt2: '',
		affrDspoId3: '',
		affrDspoNm3: '',
		affrPrcsDt3: '',

		/* 비고 */
		rmk1: '', //비고(승인자)
		rmk2: '' //비고(결재자)
	};
}

function HISTORY_PAGING_INFO() {
	return {
		currentPage: 1,
		endPage: 1,
		pageUnit: 30,
		startPage: 1,
		totalSize: 1
	};
}

export { SEARCH_PARAMS, PAGING_INFO, DETAIL_FORM, PART_MST_INFO, HISTORY_PAGING_INFO, SEARCH_POPUP_PARAMS, PPR_NO_PAGING_INFO };
